import { render, staticRenderFns } from "./ThirdReward.vue?vue&type=template&id=6a2101f6&scoped=true&"
import script from "./ThirdReward.vue?vue&type=script&lang=js&"
export * from "./ThirdReward.vue?vue&type=script&lang=js&"
import style0 from "./ThirdReward.vue?vue&type=style&index=0&id=6a2101f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2101f6",
  null
  
)

export default component.exports